import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { api } from '../utils/Api'
import { Typography, Flex, Button, Tag } from 'antd'
import Layout from '../layout/Layout'
import { CustomSpinner, CustomTable } from '../utils/CustomComponents'
import {
    EditFilled,
    PlusCircleFilled
} from '@ant-design/icons'
const { Text } = Typography

const LogisticsTruckList = ({history}) => { 
    
    const [loading, setLoading] = useState(true)
    const [logisticsTruckList, setLogisticsTruckList] = useState([])

    /**
     ** Options header (columns)
    */
    const columns = [
        {
            title: '',
            dataIndex: 'edit',
            width: 100,
            render: (_, record) => {
              return <Button 
              type="primary" 
              icon={<EditFilled twoToneColor={'white'}/>} 
              onClick={e=> history.push(`/logisticstruck/${record.id}`)}
              />
            }
        },
        {
            title: 'Truck Number',
            dataIndex: 'number',
            key: 'number',
            render: (value) => {
                return <Text>{value}</Text>
            }
        },
        {
            title: 'Truck License Plates',
            dataIndex: 'truckLicensePlates',
            key: 'truckLicensePlates',
            render: (value) => {
                return <Text>{value}</Text>
            }
        },
        {
            title: 'Truck VIN Number',
            dataIndex: 'truckVinNumber',
            key: 'truckVinNumber',
            render: (value) => {
                return <Text>{value}</Text>
            }
        },
        {
            title: 'Trailer License Plates',
            dataIndex: 'trailerLicensePlates',
            key: 'trailerLicensePlates',
            render: (value) => {
                return <Text>{value}</Text>
            }
        },
        {
            title: 'Trailer VIN Number',
            dataIndex: 'trailerVinNumber',
            key: 'trailerVinNumber',
            render: (value) => {
                return <Text>{value}</Text>
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (value) => {
                if(value === 'Enabled') return <Tag color='green'>{value}</Tag>
                if(value === 'Out of Service') return <Tag color='red'>{value}</Tag>
                if(value === 'In Maintenance') return <Tag color='yellow'>{value}</Tag>
            }
        },
        {
            title: 'Comments',
            dataIndex: 'comment',
            key: 'comment',
            render: (value) => {
                return <Text>{value}</Text>
            }
        },
    ]

    useEffect(() => {
        getLogisticsTruckList()
    }, [])
    
    const getLogisticsTruckList = async() => {
        setLoading(true)

        const url = api + '/logisticstruck/list'
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            const { data } = await axios.get(url)
            let list = []
            data.map((item, index) => {
                list.push({
                    key: index,
                    id: item._id,
                    number: item.number,
                    status: item.status,
                    truckLicensePlates: item.truckLicensePlates,
                    truckVinNumber: item.truckVinNumber,
                    trailerLicensePlates: item.trailerLicensePlates,
                    trailerVinNumber: item.trailerVinNumber,
                    comment: item.comment,
                })
            })
            setLogisticsTruckList(list)
            setLoading(false)
        } catch (err) {
            console.error(err.message)
            return null
        }
    }

    const addNewLogisticsTruck = () => {
        history.push('/newlogisticstruck')
    }
    
    const RenderTable = () => {
        return <Flex gap={'middle'} vertical>
            <Button
                onClick={addNewLogisticsTruck}
                type="primary"
                size='large'
                style={{
                    width: 200,
                }}
                icon={<PlusCircleFilled />}
            >
                New Logistics Truck
            </Button>
            <CustomTable 
            columns={columns}
            data={logisticsTruckList}
            />
        </Flex>
    }

    return (
        <Layout
            title='Logistics Trucks'
            description='Truck List'
        >
            <Flex vertical gap={'large'}>
                {
                    loading ? <CustomSpinner/> : <RenderTable/>
                } 
            </Flex>
        </Layout>
    )
}

export default LogisticsTruckList